// src/components/TopBanner.tsx
"use client";

import { Sparkles, ArrowRight } from "lucide-react";
import { useRouter } from "next/navigation";
import { motion } from "framer-motion";
import { useGetCampaignTaskStatus } from "@/hooks/challenges";
import { CAMPAIGN_ID, CAMPAIGN_GROUP_ID } from "@/config/campaign";
import { FEATURED_TASK_GUID } from "@/config/featured-task";
import { ChallengeCampaignEventState } from "@/types/challenges.types";
import { useConnection } from "@/contexts/connection-context";

export function TopBanner() {
  const router = useRouter();
  const { isAuthenticated } = useConnection();
  const { data: taskStatuses } = useGetCampaignTaskStatus(
    CAMPAIGN_ID,
    CAMPAIGN_GROUP_ID,
    isAuthenticated
  );

  const isCompleted = !!taskStatuses?.tasksStatus?.find(
    (t) => t.taskGuid === FEATURED_TASK_GUID && t.status === ChallengeCampaignEventState.SUCCESSFUL
  );

  if (isCompleted) return null;

  const handleClick = () => {
    router.push(`/quests?taskGuid=${FEATURED_TASK_GUID}`);
  };

  return (
    <motion.div
      className="group border-b border-gray-800/50 px-4 py-3 cursor-pointer transition-all duration-200 hover:bg-gray-800/20"
      style={{ backgroundColor: '#0C1113' }}
      onClick={handleClick}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2 px-2 py-1 rounded" style={{ backgroundColor: '#60FF8A' }}>
            <Sparkles className="w-4 h-4 text-black" />
            <span className="text-black text-sm font-medium">+300 PTS</span>
          </div>
          <span className="text-gray-300 text-sm">
            Upvote Rhuna on ProductHunt — three quick steps to earn 300 points
          </span>
        </div>
        <ArrowRight className="w-4 h-4 text-gray-400 transition-colors duration-200 group-hover:text-white" />
      </div>
    </motion.div>
  );
}
